<script async setup lang="ts">
import { useViewStore } from '@/stores/view.store';
import Tag from '../ui/TagComponent.vue';
const tags = ['IT', 'Дизайн', 'Маркетинг', 'HR'];

const viewStore = useViewStore();
const viewType = viewStore.getViewType;

withDefaults(
  defineProps<{
    squeeze: boolean;
  }>(),
  {
    squeeze: false
  }
);
</script>

<template>
  <article
    class="course"
    :class="squeeze && viewType == 'desktop' ? 'squeezed' : ''"
  >
    <div class="course-text">
      <h1>Центр <br />развития «Курс»</h1>
      <div>
        <p>
          Новая площадка для роста и развития «Курс».
          <br /><br />
          Это проект, где специалисты в сфере IT, маркетинга, дизайна и других
          областей смогут найти новые возможности, связи и вдохновение
        </p>
      </div>
      <div class="course-tags">
        <Tag v-for="tag in tags" :key="tag" :name="tag" />
      </div>
    </div>
    <img class="course-grid" src="/assets/icons/grid.svg" alt="" />
    <img
      height="300"
      width="220"
      class="course-image"
      src="/assets/icons/course.svg"
      alt="Курс"
    />
  </article>
</template>

<style scoped lang="scss">
.course {
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  border-radius: 60px;
  background: #153fc8;
  overflow: hidden;
  margin-bottom: 40px;

  flex: 1;
  height: auto;
  padding: 0 32px 80px;
  flex-direction: column-reverse;

  @media screen and (min-width: 1025px) {
    padding: 0;
    flex: 1 920px;
    height: 600px;
    flex-direction: row;
  }

  @media screen and (max-width: 1200px) {
    flex: 1;
    padding: 64px 0;
  }

  &-text {
    gap: 40px;
    width: 60%;
    height: 100%;
    display: flex;
    margin-left: 100px;
    flex-direction: column;
    justify-content: center;

    @media screen and (max-width: 1600px) {
      width: 60%;
      margin-left: 80px;
    }

    @media screen and (max-width: 1024px) {
      margin: 0;
      width: 100%;
      height: auto;
    }

    p {
      color: var(--color-mono-0);
      font-size: var(--font-size-s);
    }

    h1 {
      color: var(--color-mono-0);
      font-size: var(--font-size-g);

      @media screen and (max-width: 1600px) {
        line-height: var(--font-size-g);
        font-size: var(--font-size-xxxl);
      }

      @media screen and (max-width: 600px) {
        line-height: var(--font-size-xxxl);
        font-size: var(--font-size-xxl);
      }
    }
  }

  &-text,
  &-image,
  h1 {
    z-index: 1;
  }

  &-image {
    max-width: 50%;
    max-height: 100%;

    @media screen and (max-width: 1600px) {
      margin: 0;
    }

    @media screen and (max-width: 1024px) {
      margin: 0;
      transform: translate(0, 0);
    }

    @media screen and (max-width: 600px) {
      width: 220px;
      max-width: 100%;
    }
  }

  &-tags {
    gap: 8px;
    display: flex;
    flex-wrap: wrap;
  }

  &-grid {
    top: 0;
    left: 0;
    min-width: 100%;
    min-height: 100%;
    position: absolute;
  }

  @media screen and (min-width: 1025px) {
    .course-image {
      width: 330px;
      height: 450px;
      margin-right: 50px;
    }

    .course-text {
      max-width: calc(60% - 100px);

      p {
        max-width: 600px;
      }
    }
  }

  @media screen and (min-width: 1600px) {
    .course-image {
      padding: 0;
      width: 440px;
      max-height: 600px;
      margin-right: 50px;
    }

    .course-text {
      p {
        max-width: 640px;
      }
    }
  }
}

.squeezed {
  @media screen and (max-width: 1600px) {
    .course-image {
      display: none;
    }

    .course-text {
      width: 100%;
      margin: 0 60px;
      max-width: 100%;
    }
  }
}
</style>
